import { css } from '@emotion/react'
import styles, { typo } from '@mathflat/common/style'

const {
  colors: { gray, primary },
} = styles

const S = css`
  width: 600px;
  padding: 32px 24px 24px 24px;
  text-align: center;
  .icon {
    display: flex;
    justify-content: center;
    color: ${primary};
  }
  .info {
    color: var(--Colors-Green-500);
    ${typo.body02};
    font-weight: bold;
    padding: 16px 0 8px 0;
  }
  .text {
    color: ${gray.$900};
    ${typo.heading05};
    font-weight: bold;
  }
  .list {
    display: grid;
    grid-template-columns: 272px 272px;
    gap: 8px;
    padding: 40px 0;
    .item {
      height: 54px;
      ${typo.body01};
      &.selected {
        font-weight: bold;
      }
    }
  }
  .action {
    display: flex;
    justify-content: center;
  }
`

export default S
